import { render, staticRenderFns } from "./SubjectButton.vue?vue&type=template&id=01d0194e&scoped=true&"
import script from "./SubjectButton.vue?vue&type=script&lang=js&"
export * from "./SubjectButton.vue?vue&type=script&lang=js&"
import style0 from "./SubjectButton.vue?vue&type=style&index=0&id=01d0194e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d0194e",
  null
  
)

export default component.exports